<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>查询条件</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="conditions" class="flex flex-wrap justify-start align-center">
          <el-form-item style="margin-bottom: 10px;">
            <el-select v-model="conditions.shopId" placeholder="请选择店铺" clearable style="width: 180px">
              <el-option value="" label="请选择店铺"></el-option>
              <el-option v-for="(item, index) in shops" :key="index" :label="item.shopName" :value="item.shopId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-select v-model="conditions.deliverySettlementStatus" placeholder="请选择结算状态" clearable
              style="width: 150px">
              <el-option value="" label="请选择结算状态"></el-option>
              <el-option v-for="(item, index) in settlementStatuses" :key="index" :label="item.name" :value="item.statusCd">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <el-button type="primary" size="small" @click="queryOrders()">
              <i class="el-icon-search"></i> 查询
            </el-button>
            <el-button type="primary" size="small" @click="resetOrders()">
              <i class="el-icon-refresh"></i> 重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>配送费结算信息</div>
        <div class="ibox-tools">
          <el-button type="primary" size="small" :disabled="selectedOrders.length === 0" @click="markSettled()">
            标记已结算
          </el-button>
        </div>
      </div>
      <div class="">
        <div class="page-tip">
          <i class="el-icon-info"></i>
          满额免配送费阈值与平台分摊比例在 开发管理→mapping 管理 配置（MALL 域）。
        </div>
        <el-table :data="orders" style="width: 100%" border stripe @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="orderId" label="订单号" align="center"></el-table-column>
          <el-table-column label="店铺" align="center">
            <template slot-scope="scope">
              {{ scope.row.shopName || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="运费" align="right">
            <template slot-scope="scope">
              {{ scope.row.freightPrice || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column label="平台分摊" align="right">
            <template slot-scope="scope">
              {{ scope.row.deliveryPlatformShare || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column label="商家分摊" align="right">
            <template slot-scope="scope">
              {{ scope.row.deliveryShopShare || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column label="结算状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.deliverySettlementStatus === 'SETTLED'" type="success" size="mini">已结算</el-tag>
              <el-tag v-else-if="scope.row.deliverySettlementStatus === 'UNSETTLED'" type="warning" size="mini">未结算</el-tag>
              <el-tag v-else type="info" size="mini">{{ scope.row.deliverySettlementStatus || '未知' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="完成时间" align="center"></el-table-column>
        </el-table>
        <div class="settlement-footer">
          <div class="freight-sum">
            当前页运费合计：{{ pageFreightSum }} 元
            <template v-if="sumFreight !== null">
              ，全部符合条件运费合计：{{ sumFreight }} 元
            </template>
          </div>
          <el-pagination @current-change="handlePageChange" :current-page="conditions.page" :page-size="conditions.row"
            layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryDeliverySettlement, markDeliverySettled } from '@/api/order/adminDeliveryApi'
import { queryShopsByAdmin } from '@/api/admin/storeOrderManage/storeOrderManageApi'

export default {
  name: 'DeliverySettlementManage',
  data() {
    return {
      orders: [],
      total: 0,
      records: 0,
      shops: [],
      // 后端返回的当前条件运费汇总，无则展示当前页合计
      sumFreight: null,
      selectedOrders: [],
      settlementStatuses: [
        { statusCd: 'UNSETTLED', name: '未结算' },
        { statusCd: 'SETTLED', name: '已结算' }
      ],
      conditions: {
        shopId: '',
        deliverySettlementStatus: '',
        page: 1,
        row: 10
      }
    }
  },
  computed: {
    // 当前页运费合计（后端未返回 sumFreight 时使用）
    pageFreightSum() {
      const sum = this.orders.reduce((total, order) => {
        return total + (parseFloat(order.freightPrice) || 0)
      }, 0)
      return sum.toFixed(2)
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      await this.loadShops()
      this.listOrders()
    },
    async loadShops() {
      try {
        const res = await queryShopsByAdmin({ page: 1, row: 1000 })
        this.shops = res.data || []
      } catch (error) {
        console.error('加载商家列表失败:', error)
      }
    },
    async listOrders() {
      try {
        const res = await queryDeliverySettlement(this.conditions)
        this.total = res.total
        this.records = res.records
        const list = res.data || []
        this.orders = Array.isArray(list) ? list : []
        // data 层附 sumFreight（当前条件运费汇总），无则页面按当前页求和
        this.sumFreight = (res.sumFreight !== undefined && res.sumFreight !== null) ? res.sumFreight : null
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    handlePageChange(val) {
      this.conditions.page = val
      this.listOrders()
    },
    queryOrders() {
      this.conditions.page = 1
      this.listOrders()
    },
    resetOrders() {
      this.conditions = {
        shopId: '',
        deliverySettlementStatus: '',
        page: 1,
        row: 10
      }
      this.listOrders()
    },
    handleSelectionChange(val) {
      this.selectedOrders = val || []
    },
    markSettled() {
      if (this.selectedOrders.length === 0) {
        this.$message.warning('请先勾选需要标记的订单')
        return
      }
      this.$confirm(`确认将勾选的 ${this.selectedOrders.length} 笔订单标记为已结算吗？`, '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const orderIds = this.selectedOrders.map(order => order.orderId)
          const res = await markDeliverySettled({ orderIds: orderIds })
          if (res.code === 0) {
            const result = res.data || {}
            this.$message.success(`标记完成：成功 ${result.successCount || 0} 条，失败 ${result.failCount || 0} 条`)
            this.selectedOrders = []
            this.listOrders()
          }
        } catch (error) {
          console.error('请求失败处理', error)
        }
      }).catch(() => {
        // 用户取消操作，无需处理
      })
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.margin-top-sm {
  margin-top: 20px;
}

.page-tip {
  color: #606266;
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 16px;
  padding: 8px 12px;
  background-color: #f4f4f5;
  border-left: 4px solid #909399;
  border-radius: 4px;
}

.settlement-footer {
  margin-top: 10px;
}

.freight-sum {
  display: inline-block;
  color: #606266;
  font-size: 13px;
  line-height: 32px;
  margin-right: 20px;
}
</style>
